"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARB_STATISTICS = exports.ARB_GAS_INFO = exports.ARB_ADDRESS_TABLE_ADDRESS = exports.ARB_RETRYABLE_TX_ADDRESS = exports.ARB_SYS_ADDRESS = exports.NODE_INTERFACE_ADDRESS = void 0;
exports.NODE_INTERFACE_ADDRESS = '0x00000000000000000000000000000000000000C8';
exports.ARB_SYS_ADDRESS = '0x0000000000000000000000000000000000000064';
exports.ARB_RETRYABLE_TX_ADDRESS = '0x000000000000000000000000000000000000006E';
exports.ARB_ADDRESS_TABLE_ADDRESS = '0x0000000000000000000000000000000000000066';
exports.ARB_GAS_INFO = '0x000000000000000000000000000000000000006C';
exports.ARB_STATISTICS = '0x000000000000000000000000000000000000006F';
